import { STATUS_OK } from '../constants';

/**
 * Safely handle and return data on Axios response based on its status.
 */
export const handleResponse = (response, {
  onError,
  onSuccess
}) => response.status === STATUS_OK ? onSuccess(response) : onError(response);
//# sourceMappingURL=handleResponse.js.map